import MemberNoteApi from '@/api/member-note'

export default {
  data () {
    return {
      note: '',
      has_note: false
    }
  },
  methods: {
    getMemberNote (type) {
      MemberNoteApi.get(type).then(res => {
        if (res.data !== null) {
          this.note = res.data.note
          this.has_note = this.note.length !== 0
        }
      })
    },
    saveMemberNote (memberNote) {
      MemberNoteApi.save(memberNote).then(() => {
        this.$msgbox({
          title: '登録しました。',
          showClose: true,
          center: true,
          confirmButtonClass: 'btn-msg-box'
        })
        setTimeout(() => { this.$msgbox.close() }, 2000)
        // eslint-disable-next-line handle-callback-err
      }).catch(err => {
      })
    },
     getMemberNoteById (id, type) {
         MemberNoteApi.getAll(this.id).then(res => {
             let data = res.data
             if (data !== null) {
                 data.forEach(item => {
                     if (item.type === type) {
                         this.note = item.note
                     }
                 })
             }
         })
     }
  }
}
